import {handleActions, Action} from 'redux-actions';
import {AnyAction} from 'redux';
import {omit} from 'ramda';
import {
    ContentItemViewArtworkState,
    ArtworkItem,
    ArtworkStatus,
} from '../ContentItemViewArtworkTypes&Const';
import {
    CONTENT_ITEM_VIEW_ARTWORK_RESET,
    CONTENT_ITEM_VIEW_ARTWORK_SET,
    CONTENT_ITEM_VIEW_ARTWORK_WAIT,
} from './ContentItemViewArtworkActions';

export const mapArtworkItem = (item: ArtworkItem) => {
    return omit(
        ['createdAt', 'updatedAt', 'deletedAt', 'contentItemId', 'assetId'],
        item
    );
};

export const setContentItemViewArtwork = (
    state: ContentItemViewArtworkState,
    action: Action<AnyAction>
) => {
    const {artwork} = action.payload;
    const artworkImages = artwork.map(mapArtworkItem);

    return {
        artworkImages,
        isLoading: false,
    };
};

export const setContentItemViewArtworkToWait = (
    state: ContentItemViewArtworkState,
    action: {payload: number}
) => {
    const {artworkImages: images} = state;

    const artworkImages = images.map((item) => {
        if (item.id === action.payload)
            return {
                ...item,
                status: ArtworkStatus.waiting,
            };
        return item;
    });

    return {
        ...state,
        artworkImages,
    };
};

export const resetContentItemViewArtwork = () => {
    return initialState;
};

export const initialState = {
    artworkImages: [],
    isLoading: true,
};

const handlers = {
    [CONTENT_ITEM_VIEW_ARTWORK_SET]: setContentItemViewArtwork,
    [CONTENT_ITEM_VIEW_ARTWORK_RESET]: resetContentItemViewArtwork,
    [CONTENT_ITEM_VIEW_ARTWORK_WAIT]: setContentItemViewArtworkToWait,
};

export default handleActions<ContentItemViewArtworkState, AnyAction>(
    (handlers as unknown) as AnyAction,
    initialState
);
